import noop from 'lodash/noop';

// Deep import to bypass the @farmersdog/utils barrel — the barrel re-exports
// React hooks and other heavy modules that would otherwise be pulled into any
// bundle that imports from analytics. Keep this path stable when moving files
// in @farmersdog/utils/src.
import { browserOnly } from '@farmersdog/utils/src/browserOnly';

interface MissingSegmentAnalyticsProps {
  initialized?: boolean;
}

declare global {
  interface Window {
    analytics?: SegmentAnalytics.AnalyticsJS & MissingSegmentAnalyticsProps;
  }
}

const analytics = (callbackIfMethodIsUndefined?: () => void) => {
  const analyticsOrObject = browserOnly(
    window => window.analytics ?? {},
    () => ({})
  );

  return new Proxy(analyticsOrObject, {
    get(target, property) {
      const method: unknown = Reflect.get(target, property);

      if (typeof method === 'function') {
        return method;
      }

      if (property === 'user') {
        return () => ({
          id: noop,
        });
      }

      if (callbackIfMethodIsUndefined) {
        return callbackIfMethodIsUndefined;
      }

      return noop;
    },
  }) as SegmentAnalytics.AnalyticsJS;
};

export default analytics;
